import { Post } from "../../Utils/AxiosHelper/AxiosHelper";
import { Data } from "../../Models/Common/Common";

const api = {
  getAllCars: "configurations/getAllCars",
  getGeoNames: "configurations/getGeoNames",
  getProfileInfo: "accounts/getProfileInfo",
};

let command = {};
const CommonServices = {
  GetAllCars: (then: Data<any>) => {
    Post(api.getAllCars, command, then);
  },
  GetGeoNames: (then: Data<any>) => {
    Post(api.getGeoNames, command, then);
  },
  GetProfileInfo: (then: Data<any>) => {
    Post(api.getProfileInfo, command, then);
  },
};

export default CommonServices;
